var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"intersection",rawName:"v-intersection:copy-right-container",value:(_vm.handleVisible),expression:"handleVisible",arg:"copy-right-container"}],class:['contact-icon', _vm.visible ? 'ease-in' : 'ease-out']},[_c('img',{attrs:{"src":require("@/image/layouts/btn_phone_pop@3x.png")},on:{"click":_vm.handlePhone}})])
}
var staticRenderFns = []

export { render, staticRenderFns }